module.exports = __webpack_public_path__ + "img/app-bar-background.aaa09695.jpg";